import { useAuth } from "@/hooks/use-auth";
import ManagerLayout from "@/components/layout/ManagerLayout";
import { DashboardContent } from "@/components/dashboard/DashboardContent";
import { Loader2 } from "lucide-react";
import GuestLayout from "@/components/layout/GuestLayout";

export default function DashboardPage() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    // If not logged in, redirect to login page
    typeof window !== 'undefined' && (window.location.href = "/auth");
    return null;
  }

  const role = user.role.toLowerCase();

  if (role === "guest") {
    return (
      <GuestLayout>
        <div className="container py-8">
          <DashboardContent user={user} />
        </div>
      </GuestLayout>
    );
  }

  // Get the appropriate title based on user role
  const getDashboardTitle = () => {
    if (role === 'owner' || role === 'manager') {
      return "Owner Dashboard";
    } else if (role === 'agent') {
      return "Agent Dashboard";
    } else {
      return "Guest Dashboard";
    }
  };

  return (
    <ManagerLayout>
      <div className="container py-8">
        {/* <div className="mb-8">
          <h1 className="text-3xl font-bold">{getDashboardTitle()}</h1>
          <p className="text-muted-foreground mt-1">Your StayMiddle platform overview</p>
        </div> */}
        <DashboardContent user={user} />
      </div>
    </ManagerLayout>
  );
}